export default "__VITE_ASSET__R2EBpleV__"